import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { winesFeatureGuard } from './core/wines-feature.guard';
import { experiencesFeatureGuard, experiencesPlatformFeatureGuard } from './core/experiences-feature.guard';
import { languageRouteChildGuard, languageRouteGuard } from './core/language-route.guard';

const localizedRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'welcome'
  },
  {
    path: 'welcome',
    loadComponent: () => import('./features/welcome/welcome.component').then((m) => m.WelcomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register.component').then((m) => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-password.component').then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password.component').then((m) => m.ResetPasswordComponent)
  },
  {
    path: 'account',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@shared/partner-ui/features/winery-account/winery-account.component').then(
        (m) => m.WineryAccountComponent
      )
  },
  {
    path: 'verify-email',
    canActivate: [authGuard],
    loadComponent: () => import('./features/auth/verify-email.component').then((m) => m.VerifyEmailComponent)
  },
  {
    path: 'wines',
    canActivate: [authGuard],
    canMatch: [winesFeatureGuard],
    loadComponent: () =>
      import('@shared/partner-ui/features/wines/wines.component').then(
        (m) => m.WinesComponent
      )
  },
  {
    path: 'story',
    canActivate: [authGuard],
    loadComponent: () => import('./features/winery-story/winery-story.component').then((m) => m.WineryStoryComponent)
  },
  {
    path: 'experiences/new',
    pathMatch: 'full',
    redirectTo: 'experiences'
  },
  {
    path: 'experiences/:slug',
    pathMatch: 'full',
    redirectTo: 'experiences/:slug/details'
  },
  {
    path: 'experiences/:slug/bookings/:date/print',
    canActivate: [authGuard],
    canMatch: [experiencesFeatureGuard],
    loadComponent: () =>
      import('./features/experiences/experience-bookings-print.component').then((m) => m.ExperienceBookingsPrintComponent)
  },
  {
    path: 'experiences/:slug/:tab',
    canActivate: [authGuard],
    canMatch: [experiencesFeatureGuard],
    loadComponent: () =>
      import('./features/experiences/experience-detail.component').then((m) => m.ExperienceDetailComponent)
  },
  {
    path: 'experiences',
    canActivate: [authGuard],
    canMatch: [experiencesPlatformFeatureGuard],
    loadComponent: () => import('./features/experiences/experiences.component').then((m) => m.ExperiencesComponent)
  },
  {
    path: 'tours/new',
    pathMatch: 'full',
    redirectTo: 'experiences'
  },
  {
    path: 'tours/:slug',
    pathMatch: 'full',
    redirectTo: 'experiences/:slug/details'
  },
  {
    path: 'tours/:slug/bookings/:date/print',
    pathMatch: 'full',
    redirectTo: 'experiences/:slug/bookings/:date/print'
  },
  {
    path: 'tours/:slug/:tab',
    pathMatch: 'full',
    redirectTo: 'experiences/:slug/:tab'
  },
  {
    path: 'tours',
    pathMatch: 'full',
    redirectTo: 'experiences'
  },
  {
    path: '**',
    redirectTo: 'welcome'
  }
];

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [languageRouteGuard],
    children: []
  },
  {
    path: ':lang',
    canActivate: [languageRouteGuard],
    canActivateChild: [languageRouteChildGuard],
    children: localizedRoutes
  },
  {
    path: '**',
    redirectTo: ''
  }
];
